import React, { useEffect, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import PaginationComponent from "../../util/pagination/pagination";
import { API_URL } from "../../services/api";
import { useGetPagination } from "../../services/GetService";
import Search from "../../util/search/search";
import { FaPencilAlt, FaRegAddressBook } from "react-icons/fa";
import { FcBarChart } from "react-icons/fc";
import { FcAbout } from "react-icons/fc";
import ModalComponent from "./modal";
import toast, { Toaster } from "react-hot-toast";
import SummaryModal from "./SummaryModal";
import StatisticsModal from "./StatisticsModal";

const Companies = ({ setShowLoading }) => {
    const [paginate, setPaginate] = useState(API_URL + "companies/pagination");
    const [response] = useGetPagination(paginate);
    const [company, setCompany] = useState({});
    const [messsage, setMesssage] = useState("");
    const [showSummary, setShowSummary] = useState(false);
    const [selectedCompanyId, setSelectedCompanyId] = useState(null);
    const [showStatistics, setShowStatistics] = useState(false);

    useEffect(() => {
        setShowLoading(false);
    }, []);

    useEffect(() => {
        if (messsage) {
            if (messsage.success) {
                toast.success(messsage.message);
            } else {
                toast.error(messsage.message);
            }
        }
    }, [messsage]);

    const [showModal, setShowModal] = useState(false);

    return (
        <>
            <Container className="pt-5">
                <Toaster position="top-left" reverseOrder={false} />

                <Row>
                    <Col className="col-12 d-flex justify-content-between align-items-center">
                        <Button
                            variant="primary d-flex justify-content-between align-items-center pt-2 pb-2"
                            onClick={() => {
                                setShowModal(true);
                                setCompany("");
                            }}
                        >
                            <FaRegAddressBook
                                color="#FFFFFF"
                                onClick={() => {
                                    setShowModal(true);
                                    setCompany("");
                                }}
                            />
                        </Button>
                        <Col className="col-3">
                            <Search
                                setPaginate={setPaginate}
                                url="company"
                                originalUrl="companies/pagination"
                            />
                        </Col>
                    </Col>
                    <Col sm={12}>
                        <Table striped bordered hover className="table">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Rut</th>
                                    <th>Nombre</th>
                                    <th>Teléfono</th>
                                    <th>Correo</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {response.data !== undefined &&
                                    response.data.map((company) => {
                                        return (
                                            <tr key={company.id}>
                                                <th>{company.id}</th>
                                                <td>{company.rut}</td>
                                                <td>{company.name}</td>
                                                <td>{company.phone}</td>
                                                <td>{company.mail}</td>
                                                <td>
                                                    <FaPencilAlt
                                                        color="#0D6EFD"
                                                        onClick={() => {
                                                            setCompany(company);
                                                            setShowModal(true);
                                                        }}
                                                    />
                                                    <FcAbout 
                                                        className="mx-2"
                                                        size="1.4em"
                                                        onClick={() => {
                                                            setSelectedCompanyId(company.id);
                                                            setShowSummary(true);
                                                        }}
                                                    />
                                                    <FcBarChart
                                                        className="mx-2"
                                                        size="1.4em"
                                                        onClick={() => {
                                                            setSelectedCompanyId(company.id);
                                                            setShowStatistics(true);
                                                        }}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                            </tbody>
                        </Table>
                        <PaginationComponent
                            response={response}
                            setPaginate={setPaginate}
                        />
                    </Col>
                </Row>
            </Container>
            <ModalComponent
                showModal={showModal}
                setShowModal={setShowModal}
                company={company}
                setMesssage={setMesssage}
                setPaginate={setPaginate}
            />
            <SummaryModal 
                show={showSummary}
                handleClose={() => setShowSummary(false)}
                companyId={selectedCompanyId}
            />
            <StatisticsModal 
                show={showStatistics}
                handleClose={() => setShowStatistics(false)}
                companyId={selectedCompanyId}
            />
        </>
    );
};

export default Companies;
